import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcPopoverModule } from '@datachain/ui-sdk/components/app-popover';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import { DcNavigateDirectiveModule } from '@datachain/ui-sdk/directives';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { GridActionPopupComponent } from './components/grid-action-popup/grid-action-popup.component';
import { GridListComponent } from './components/grid-list/grid-list.component';
import { GridAdapter } from './grid.adapter';
import {
	GridEffects,
	GridFeatureKey,
	gridReducers,
	GridSelector,
} from './store';

@NgModule({
	declarations: [GridListComponent, GridActionPopupComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		StoreModule.forFeature(GridFeatureKey, gridReducers),
		EffectsModule.forFeature([GridEffects]),
		DxDataGridModule,
		NgOptimizedImage,
		FormsModule,
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcBadgeModule,
		DcAvatarModule,
		DcNavigateDirectiveModule,
		DcBreadcrumbModule,
		DcPopoverModule,
		DcButtonModule,
	],
	providers: [GridAdapter, GridSelector],
})
export class GridModule {
	public constructor(private readonly injector: Injector) {
		const gridListCmpElement = createCustomElement(GridListComponent, {
			injector,
		});
		customElements.define('app-grid-list', gridListCmpElement);
	}
}
